// import { HandThumbDownIcon, HandThumbUpIcon } from '@heroicons/react/24/outline'
// import JSConfetti from 'js-confetti'
import { Button, Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { useLoaderData } from '@remix-run/react'
import clsx from 'clsx'
import { getNewQuoteURL } from '~/helpers'
import type { loader } from '~/routes/report/v2/layout'
import * as gtag from '~/utils/gtag'

export function PromoBarLatest() {
  const { report, promoBarText } = useLoaderData<typeof loader>()
  if (!report.report.isPublicPromo) return null

  // function thumbsUp() {
  //   const jsConfetti = new JSConfetti()
  //   jsConfetti.addConfetti()
  //   if (window.gtag) {
  //     window.gtag('event', 'reportPromoThumbsUp')
  //   }
  // }

  // function thumbsDown() {
  //   if (window.gtag) {
  //     window.gtag('event', 'reportPromoThumbsDown')
  //   }
  // }
  //
  function clickedPromo() {
    gtag.event({
      action: 'link_click',
      category: 'Report Promo Bar',
      label: promoBarText ?? '',
    })
  }
  return (
    <nav
      className={clsx(
        'p-4 gap-3 flex justify-between items-center sticky top-0 z-50',
        report.report.brand === 'Point Hacks' ? 'bg-[#c00]' : 'bg-[#283071]',
      )}
    >
      <div className="flex items-center space-x-4 flex-1 justify-center">
        {promoBarText ? (
          <Popover className="relative text-white">
            <PopoverButton className="outline-none w-full">
              {({ open }) => (
                <span>
                  Let us help you find your seats {`${open ? '👇' : '👉'}`}
                </span>
              )}
            </PopoverButton>
            <PopoverPanel
              transition
              className="flex justify-between gap-6 mt-6"
            >
              <a
                target="_blank"
                className="py-1 px-2 outline-none border rounded sm font-semibold bg-white bg-opacity-15 hover:bg-opacity-25 text-center"
                onClick={clickedPromo}
                href={getNewQuoteURL(report.report.brand)}
                rel="noreferrer"
              >
                Build your own itinerary
              </a>
              <a
                target="_blank"
                className="py-1 px-2 outline-none border rounded sm font-semibold bg-white bg-opacity-15 hover:bg-opacity-25 text-center"
                onClick={clickedPromo}
                href="https://www.pointhacks.com.au/reward-seat-alerts/"
                rel="noreferrer"
              >
                Sign up for Seat Alerts
              </a>
            </PopoverPanel>
          </Popover>
        ) : null}
      </div>

      {/* <div className="flex items-center space-x-4">
        <button className="text-white hover:text-zinc-300">
          <HandThumbUpIcon onClick={thumbsUp} className="h-6 w-6" />
        </button>
        <button className="text-white hover:text-zinc-300">
          <HandThumbDownIcon onClick={thumbsDown} className="h-6 w-6" />
        </button>
      </div> */}
    </nav>
  )
}
